import { elsterDocxUtils, emptyLine } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import { DMVER_ONE, DMVER_SUBSIDY } from '../constants/elsterDocxConstants';
import generalTable from '../utils/generalTable';
import { bookmarkParagraphOptions, bookmarkStyle, grayTitlesMain } from '../styles/elsterDocStyles';
const section3 = (data, elsterVersion) => {
  var _data$elster_deminimi3, _data$elster_deminimi4;
  const {
    t
  } = i18n;
  const {
    createBookmark,
    createTextRunInParagraph
  } = elsterDocxUtils;
  const mainParagraphOptions = {
    spacing: {
      before: 300,
      after: 200
    }
  };
  const generateTableForSubsidies = type => {
    var _data$elster_deminimi, _data$elster_deminimi2;
    const subsidies = ((_data$elster_deminimi = (_data$elster_deminimi2 = data.elster_deminimis) === null || _data$elster_deminimi2 === void 0 ? void 0 : _data$elster_deminimi2.deminimis_subsidies) !== null && _data$elster_deminimi !== void 0 ? _data$elster_deminimi : []).filter(d => d.subsidy_type === type);
    if (subsidies.length === 0) {
      return [generalTable({}, DMVER_SUBSIDY), emptyLine];
    }
    return subsidies.flatMap(s => [generalTable(s, DMVER_SUBSIDY), emptyLine]);
  };
  return [createBookmark(t('tk_dem_3'), 'anchor_tk_dem_3', bookmarkStyle, bookmarkParagraphOptions), createTextRunInParagraph(t(elsterVersion === 'version_8' ? 'tk_deminimis_section3_3_subtitle_v8' : 'tk_deminimis_section3_3_subtitle'), grayTitlesMain, mainParagraphOptions), generalTable({
    deminimies_ver: (_data$elster_deminimi3 = data.elster_deminimis) === null || _data$elster_deminimi3 === void 0 ? void 0 : _data$elster_deminimi3.deminimies_ver
  }, DMVER_ONE), ...((_data$elster_deminimi4 = data.elster_deminimis) !== null && _data$elster_deminimi4 !== void 0 && _data$elster_deminimi4.deminimies_ver ? [createTextRunInParagraph(t('dmver_erklarung_2'), grayTitlesMain, mainParagraphOptions), ...generateTableForSubsidies('explanation_2'), createTextRunInParagraph(t('dmver_erklarung_3'), grayTitlesMain, mainParagraphOptions), ...generateTableForSubsidies('explanation_3')] : []), emptyLine];
};
export default section3;